<script>
    import LogoIcon from "./assets/logo.png";
    import { page } from "$app/stores";
    import { authenticated_user, current_user, support_modal_open } from "$service/store";

    // "Support" only makes sense for signed-in users on app pages (same gate the
    // layout uses to mount SupportChat).
    $: show_support = $current_user && $page.url.pathname !== "/" && typeof $authenticated_user?.id !== "undefined";
</script>

<footer class="mt-auto" style="background: #fafafa; border-top: 1px solid #d5d5e0;">
    <div class="relative flex flex-col md:flex-row items-center justify-between py-4 md:py-2 px-6 md:px-16 gap-2 md:gap-0 text-center md:text-left">
        <!-- Left: logo + copyright -->
        <div class="flex items-center gap-4 shrink-0">
            <img src={LogoIcon} alt="SmartClaim logo" width="32" style="mix-blend-mode: multiply;" />
            <span class="text-base font-normal text-navy whitespace-nowrap">© 2026 SmartClaim. All Rights Reserved.</span>
        </div>

        <!-- Center: disclaimer — absolutely centred on the full width -->
        <p class="hidden md:block absolute left-1/2 -translate-x-1/2 text-sm md:text-base font-normal text-navy pointer-events-none text-center whitespace-nowrap">
            Not tax advice. The user is solely responsible for reviewing and verifying all output.
        </p>
        <!-- Mobile: normal flow -->
        <p class="md:hidden text-sm font-normal text-navy pointer-events-none text-center">
            Not tax advice. The user is solely responsible for reviewing and verifying all output.
        </p>

        <!-- Right: terms + support -->
        <div class="flex items-center gap-4 shrink-0">
            <a href="/terms" class="text-base font-normal text-navy hover:opacity-70 underline transition whitespace-nowrap">
                Terms and Conditions
            </a>
            {#if show_support}
                <button
                    type="button"
                    class="text-base font-normal text-navy hover:opacity-70 underline transition whitespace-nowrap"
                    on:click={() => support_modal_open.set(true)}
                >
                    Support
                </button>
            {/if}
        </div>
    </div>
</footer>
